/**
 * SIFRE KURALLARI — sunucudaki mirror.
 *
 * Kaynak: dovizhub-iam-management/src/modules/password-policy.js. Sunucu ayni
 * kurallari uyguluyor ve ILK karsilanmayan kuralin mesajini donuyor. Buradaki
 * liste ondan KATI OLMAMALI: formun "uygun" dedigi bir sifreyi sunucunun
 * reddetmesi, kullaniciya sebebi gorunmeyen bir hata verir.
 *
 * Ozel karakter kumesi de sunucudan birebir: [!@#$%^&*()\-_"=+{}; :,<.>]
 * (bosluk dahil). Genisletmek, sunucunun reddedecegi bir sifreyi kabul
 * ettirmek demek.
 *
 * `messageKey` metin DEGIL ceviri anahtari: liste modul seviyesinde yasiyor,
 * burada t() cagrilamaz.
 */
export const PASSWORD_MIN_LENGTH = 8;

export type PasswordRule = {
  id: string;
  messageKey: string;
  test: (value: string) => boolean;
};

export const PASSWORD_RULES: readonly PasswordRule[] = Object.freeze([
  {
    id: 'min',
    messageKey: 'validation.passwordMin',
    test: (value: string) => value.length >= PASSWORD_MIN_LENGTH,
  },
  { id: 'lower', messageKey: 'validation.passwordLower', test: (value: string) => /[a-z]/.test(value) },
  { id: 'upper', messageKey: 'validation.passwordUpper', test: (value: string) => /[A-Z]/.test(value) },
  { id: 'digit', messageKey: 'validation.passwordDigit', test: (value: string) => /\d/.test(value) },
  {
    id: 'special',
    messageKey: 'validation.passwordSpecial',
    test: (value: string) => /[!@#$%^&*()\-_"=+{}; :,<.>]/.test(value),
  },
]);
